/**
 * Microservices observability module gate (Vite: VITE_ENABLE_MICROSERVICES_MODULE).
 * - `VITE_ENABLE_MICROSERVICES_MODULE=false` → always off
 * - `VITE_ENABLE_MICROSERVICES_MODULE=true` → always on
 * - unset → on in development only (safe default for production bundles)
 */
export function isMicroservicesModuleEnabled(): boolean {
  const v = import.meta.env.VITE_ENABLE_MICROSERVICES_MODULE;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return Boolean(import.meta.env.DEV);
}
